import * as React from 'react';
import { HomePageContent } from "../HomePageContent/HomePageContent";
import BomListingHeader from "./BomListing/BomListingHeader/BomListingHeader";

export function BomProductListing() {

    return (
        <>
            <BomListingHeader isBomPLP={true}/> 
            <HomePageContent isBomPLP={true}/>
        </>
    );

}
